(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BC-Circuito-Monaco"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function init(section){
    if (section.dataset.bcvrInit === 'true') return;
    section.dataset.bcvrInit = 'true';

    var storeKey = 'bcVuelta_' + section.id;

    var path = section.querySelector('.bc-vr__track-path');
    var car = section.querySelector('[data-car]');
    var finish = section.querySelector('[data-finish]');
    var lights = section.querySelectorAll('.bc-vr__light');
    var hud = section.querySelector('[data-hud]');
    var startBtn = section.querySelector('[data-start]');
    var stopBtn = section.querySelector('[data-stop]');
    var hint = section.querySelector('[data-hint]');
    var result = section.querySelector('[data-result]');
    var badge = section.querySelector('[data-badge]');
    var timeEl = section.querySelector('[data-time]');
    var emailStep = section.querySelector('[data-email-step]');
    var emailInput = section.querySelector('[data-email-input]');
    var emailSubmit = section.querySelector('[data-email-submit]');
    var emailError = section.querySelector('[data-email-error]');
    var codeStep = section.querySelector('[data-code-step]');
    var codeValue = section.querySelector('[data-code-value]');
    var codeDesc = section.querySelector('[data-code-desc]');
    var copyBtn = section.querySelector('[data-copy]');
    var playedPanel = section.querySelector('[data-played]');
    var playedCode = section.querySelector('[data-played-code]');
    var playedCopy = section.querySelector('[data-played-copy]');

    if (!path || !car) return;
    var totalLen = path.getTotalLength();
    var lapMs = parseInt(section.dataset.lap,10) || 2800;
    var diff = section.dataset.difficulty || 'medio';
    var replay = section.dataset.replay || 'once';

    var tiers = {
      facil:  { t1:0.05,  t2:0.12 },
      medio:  { t1:0.03,  t2:0.08 },
      dificil:{ t1:0.015, t2:0.05 }
    }[diff] || { t1:0.03, t2:0.08 };

    var codes = {
      1: { code: section.dataset.t1Code || 'POLE15',  badge: section.dataset.t1Badge || '¡Pole Position!',      desc: section.dataset.t1Desc || '15% de descuento' },
      2: { code: section.dataset.t2Code || 'PODIO10', badge: section.dataset.t2Badge || '¡Podio!',              desc: section.dataset.t2Desc || '10% de descuento' },
      3: { code: section.dataset.t3Code || 'META5',   badge: section.dataset.t3Badge || '¡Llegaste a la meta!', desc: section.dataset.t3Desc || '5% de descuento' }
    };

    function getSaved(){ try { return JSON.parse(localStorage.getItem(storeKey) || 'null'); } catch(e){ return null; } }
    function canPlay(){
      if (replay === 'free') return true;
      var s = getSaved();
      if (!s) return true;
      if (replay === 'daily'){
        var today = new Date().toISOString().slice(0,10);
        return s.date !== today;
      }
      return false;
    }
    function saveResult(tier){
      var data = { tier: tier, code: codes[tier].code, date: new Date().toISOString().slice(0,10), ts: Date.now() };
      try { localStorage.setItem(storeKey, JSON.stringify(data)); } catch(e){}
    }

    // --- Geometría de la pista ---
    function pointAt(frac){ return path.getPointAtLength((((frac % 1) + 1) % 1) * totalLen); }
    function headingAt(frac){
      var d = 0.004;
      var a = pointAt(frac - d), b = pointAt(frac + d);
      return Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
    }
    function setCarAt(frac){
      var p = pointAt(frac), h = headingAt(frac);
      car.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ',' + p.y.toFixed(1) + ') rotate(' + h.toFixed(1) + ')');
    }

    // Posiciona la línea de meta (perpendicular a la pista en frac=0)
    (function placeFinish(){
      if (!finish) return;
      var p = pointAt(0), h = headingAt(0);
      finish.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ',' + p.y.toFixed(1) + ') rotate(' + (h + 90).toFixed(1) + ')');
    })();

    setCarAt(0);

    if (!canPlay()){
      var s = getSaved();
      if (s && playedCode){ playedCode.textContent = s.code; }
      section.setAttribute('data-state','played');
      playedPanel.hidden = false;
    }

    var raf = null, startTime = 0, running = false;

    function loop(now){
      if (!running) return;
      var frac = ((now - startTime) % lapMs) / lapMs;
      setCarAt(frac);
      raf = requestAnimationFrame(loop);
    }

    function startCountdown(){
      section.setAttribute('data-state','countdown');
      startBtn.hidden = true;
      hint.textContent = 'Preparados...';
      var i = 0;
      lights.forEach(function(l){ l.classList.remove('is-on'); });
      var iv = setInterval(function(){
        if (i < lights.length){ lights[i].classList.add('is-on'); i++; return; }
        clearInterval(iv);
        setTimeout(function(){
          lights.forEach(function(l){ l.classList.remove('is-on'); });
          beginRun();
        }, 350 + Math.random()*500);
      }, 600);
    }

    function beginRun(){
      section.setAttribute('data-state','running');
      running = true; startTime = performance.now();
      stopBtn.hidden = false;
      hud.classList.add('is-visible'); hud.textContent = '¡GO!';
      hint.textContent = 'Toca DETENER al cruzar la meta';
      raf = requestAnimationFrame(loop);
    }

    function stopRun(){
      if (!running) return;
      running = false;
      if (raf) cancelAnimationFrame(raf);
      var now = performance.now();
      var frac = ((now - startTime) % lapMs) / lapMs;
      setCarAt(frac);
      var gap = Math.min(frac, 1 - frac);
      var gapMs = gap * lapMs;

      var tier = 3;
      if (gap <= tiers.t1) tier = 1;
      else if (gap <= tiers.t2) tier = 2;

      stopBtn.hidden = true;
      hud.classList.remove('is-visible');
      showResult(tier, gapMs);
    }

    function showResult(tier, gapMs){
      section.setAttribute('data-state','result');
      result.hidden = false;
      badge.textContent = codes[tier].badge;
      timeEl.textContent = 'Diferencia con la meta: +' + (gapMs/1000).toFixed(3) + 's';
      result.dataset.tier = tier;
      emailStep.hidden = false;
      codeStep.hidden = true;
    }

    function revealCode(tier){
      codeStep.hidden = false;
      emailStep.hidden = true;
      codeValue.textContent = codes[tier].code;
      codeDesc.textContent = codes[tier].desc;
      saveResult(tier);
    }

    function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    function captureEmail(email){
      var tags = section.dataset.emailTags || 'newsletter,vuelta-rapida';
      var body = new URLSearchParams();
      body.append('form_type','customer');
      body.append('utf8','\u2713');
      body.append('contact[email]', email);
      body.append('contact[tags]', tags);
      return fetch('/contact', {
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
        body: body.toString()
      }).catch(function(){});
    }

    if (emailSubmit){
      emailSubmit.addEventListener('click', function(){
        var v = (emailInput.value || '').trim();
        if (!validEmail(v)){ emailError.hidden = false; emailInput.focus(); return; }
        emailError.hidden = true;
        emailSubmit.disabled = true; emailSubmit.textContent = '...';
        var tier = parseInt(result.dataset.tier,10) || 3;
        captureEmail(v).then(function(){ revealCode(tier); });
      });
      emailInput.addEventListener('keydown', function(e){ if (e.key==='Enter'){ e.preventDefault(); emailSubmit.click(); } });
    }

    function wireCopy(btn, getText){
      if (!btn) return;
      btn.addEventListener('click', function(){
        var txt = getText();
        var done = function(){ btn.textContent='¡Copiado!'; btn.classList.add('is-copied'); setTimeout(function(){ btn.textContent='Copiar'; btn.classList.remove('is-copied'); },1800); };
        if (navigator.clipboard){ navigator.clipboard.writeText(txt).then(done).catch(done); } else { done(); }
      });
    }
    wireCopy(copyBtn, function(){ return codeValue.textContent; });
    wireCopy(playedCopy, function(){ return playedCode.textContent; });

    if (startBtn) startBtn.addEventListener('click', startCountdown);
    if (stopBtn) stopBtn.addEventListener('click', stopRun);
  }

  function initAll(){ document.querySelectorAll('[data-section-type="bc-vr"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function(e){
    var s = e.target.querySelector('[data-section-type="bc-vr"]');
    if (s){ s.dataset.bcvrInit=''; init(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BC-Featured-Products"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function setDuration(track, section) {
    if (!track) return;
    var pxPerSec = parseInt(section.dataset.speed, 10) || 50;
    var setWidth = track.scrollWidth / 2;
    if (setWidth <= 0) return;
    var duration = setWidth / pxPerSec;
    track.style.setProperty('--bcf-duration', duration.toFixed(2) + 's');
  }

  function initFeatured(section) {
    if (section.dataset.bcFeaturedInit === 'true') return;
    section.dataset.bcFeaturedInit = 'true';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tracks = section.querySelectorAll('[data-track]');
    var tabs = section.querySelectorAll('[data-tab-target]');
    var panels = section.querySelectorAll('[data-panel]');

    // Color inicial del primer panel activo (para título + cards)
    var firstActive = section.querySelector('.bc-featured__panel.is-active');
    if (firstActive) {
      section.style.setProperty('--panel-color', getComputedStyle(firstActive).getPropertyValue('--panel-color').trim() || '#DC0000');
    }

    function recalcAll() {
      if (reduce) return;
      tracks.forEach(function(t) { setDuration(t, section); });
    }

    if (document.readyState === 'complete') { recalcAll(); }
    else { window.addEventListener('load', recalcAll); }
    recalcAll();
    window.addEventListener('resize', debounce(recalcAll, 250));

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.dataset.tabTarget;
        tabs.forEach(function(t) {
          var active = t.dataset.tabTarget === target;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        var activePanel = null;
        panels.forEach(function(p) {
          var active = p.dataset.panel === target;
          p.classList.toggle('is-active', active);
          if (active) { p.removeAttribute('hidden'); activePanel = p; }
          else { p.setAttribute('hidden', ''); }
        });
        // Propaga el color de la escudería a toda la sección
        if (activePanel) {
          var col = getComputedStyle(activePanel).getPropertyValue('--panel-color').trim();
          if (col) section.style.setProperty('--panel-color', col);
          var track = activePanel.querySelector('[data-track]');
          if (track) setDuration(track, section);
        }
      });

      tab.addEventListener('keydown', function(e) {
        var list = Array.prototype.slice.call(tabs);
        var idx = list.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight') next = list[(idx + 1) % list.length];
        if (e.key === 'ArrowLeft') next = list[(idx - 1 + list.length) % list.length];
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    });
  }

  function debounce(fn, wait) {
    var t;
    return function() { clearTimeout(t); t = setTimeout(fn, wait); };
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="bc-featured"]').forEach(initFeatured);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function(e) {
    var s = e.target.querySelector('[data-section-type="bc-featured"]');
    if (s) { s.dataset.bcFeaturedInit = ''; initFeatured(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BC-Trust-Bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initTrust(section) {
    if (section.dataset.bcTrustInit === 'true') return;
    section.dataset.bcTrustInit = 'true';

    const items = section.querySelectorAll('[data-trust-item]');
    if (!items.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canHover = window.matchMedia('(hover: hover)').matches;

    // Spotlight que sigue el mouse (solo en dispositivos con hover)
    if (canHover && !reduceMotion) {
      items.forEach(item => {
        item.addEventListener('pointermove', (e) => {
          const rect = item.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          item.style.setProperty('--mx', x + '%');
          item.style.setProperty('--my', y + '%');
        });
        item.addEventListener('pointerleave', () => {
          item.style.setProperty('--mx', '50%');
          item.style.setProperty('--my', '50%');
        });
      });
    }

    // Entrada escalonada al hacer scroll
    if (reduceMotion) {
      items.forEach(i => i.classList.add('is-visible'));
      return;
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });
      items.forEach(i => observer.observe(i));
    } else {
      items.forEach(i => i.classList.add('is-visible'));
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="bc-trust"]').forEach(initTrust);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-section-type="bc-trust"]');
    if (section) initTrust(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BC-Vuelta-Rapida"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function init(section){
    if (section.dataset.bcvrInit === 'true') return;
    section.dataset.bcvrInit = 'true';

    var storeKey = 'bcVuelta_' + section.id;

    var path = section.querySelector('.bc-vr__track-path');
    var car = section.querySelector('[data-car]');
    var lights = section.querySelectorAll('.bc-vr__light');
    var hud = section.querySelector('[data-hud]');
    var startBtn = section.querySelector('[data-start]');
    var stopBtn = section.querySelector('[data-stop]');
    var hint = section.querySelector('[data-hint]');
    var result = section.querySelector('[data-result]');
    var badge = section.querySelector('[data-badge]');
    var timeEl = section.querySelector('[data-time]');
    var emailStep = section.querySelector('[data-email-step]');
    var emailInput = section.querySelector('[data-email-input]');
    var emailSubmit = section.querySelector('[data-email-submit]');
    var emailError = section.querySelector('[data-email-error]');
    var codeStep = section.querySelector('[data-code-step]');
    var codeValue = section.querySelector('[data-code-value]');
    var codeDesc = section.querySelector('[data-code-desc]');
    var copyBtn = section.querySelector('[data-copy]');
    var playedPanel = section.querySelector('[data-played]');
    var playedCode = section.querySelector('[data-played-code]');
    var playedCopy = section.querySelector('[data-played-copy]');

    if (!path || !car) return;
    var totalLen = path.getTotalLength();
    var lapMs = parseInt(section.dataset.lap,10) || 2800;
    var diff = section.dataset.difficulty || 'medio';
    var replay = section.dataset.replay || 'once';

    var tiers = {
      facil:  { t1:0.05,  t2:0.12 },
      medio:  { t1:0.03,  t2:0.08 },
      dificil:{ t1:0.015, t2:0.05 }
    }[diff] || { t1:0.03, t2:0.08 };

    var codes = {
      1: { code: section.dataset.t1Code || 'POLE15',  badge: section.dataset.t1Badge || '¡Pole Position!',      desc: section.dataset.t1Desc || '15% de descuento' },
      2: { code: section.dataset.t2Code || 'PODIO10', badge: section.dataset.t2Badge || '¡Podio!',              desc: section.dataset.t2Desc || '10% de descuento' },
      3: { code: section.dataset.t3Code || 'META5',   badge: section.dataset.t3Badge || '¡Llegaste a la meta!', desc: section.dataset.t3Desc || '5% de descuento' }
    };

    function getSaved(){ try { return JSON.parse(localStorage.getItem(storeKey) || 'null'); } catch(e){ return null; } }
    function canPlay(){
      if (replay === 'free') return true;
      var s = getSaved();
      if (!s) return true;
      if (replay === 'daily'){
        var today = new Date().toISOString().slice(0,10);
        return s.date !== today;
      }
      return false;
    }
    function saveResult(tier){
      var data = { tier: tier, code: codes[tier].code, date: new Date().toISOString().slice(0,10), ts: Date.now() };
      try { localStorage.setItem(storeKey, JSON.stringify(data)); } catch(e){}
    }

    if (!canPlay()){
      var s = getSaved();
      if (s && playedCode){ playedCode.textContent = s.code; }
      section.setAttribute('data-state','played');
      playedPanel.hidden = false;
    }

    function setCarAt(frac){
      var pt = path.getPointAtLength((frac % 1) * totalLen);
      car.setAttribute('transform','translate(' + pt.x.toFixed(1) + ',' + pt.y.toFixed(1) + ')');
    }
    setCarAt(0);

    var raf = null, startTime = 0, running = false;

    function loop(now){
      if (!running) return;
      var frac = ((now - startTime) % lapMs) / lapMs;
      setCarAt(frac);
      raf = requestAnimationFrame(loop);
    }

    function startCountdown(){
      section.setAttribute('data-state','countdown');
      startBtn.hidden = true;
      hint.textContent = 'Preparados...';
      var i = 0;
      lights.forEach(function(l){ l.classList.remove('is-on'); });
      var iv = setInterval(function(){
        if (i < lights.length){ lights[i].classList.add('is-on'); i++; return; }
        clearInterval(iv);
        setTimeout(function(){
          lights.forEach(function(l){ l.classList.remove('is-on'); });
          beginRun();
        }, 350 + Math.random()*500);
      }, 600);
    }

    function beginRun(){
      section.setAttribute('data-state','running');
      running = true; startTime = performance.now();
      stopBtn.hidden = false;
      hud.classList.add('is-visible'); hud.textContent = '¡GO!';
      hint.textContent = 'Toca DETENER al cruzar la meta';
      raf = requestAnimationFrame(loop);
    }

    function stopRun(){
      if (!running) return;
      running = false;
      if (raf) cancelAnimationFrame(raf);
      var now = performance.now();
      var frac = ((now - startTime) % lapMs) / lapMs;
      setCarAt(frac);
      var gap = Math.min(frac, 1 - frac);
      var gapMs = gap * lapMs;

      var tier = 3;
      if (gap <= tiers.t1) tier = 1;
      else if (gap <= tiers.t2) tier = 2;

      stopBtn.hidden = true;
      hud.classList.remove('is-visible');
      showResult(tier, gapMs);
    }

    function showResult(tier, gapMs){
      section.setAttribute('data-state','result');
      result.hidden = false;
      badge.textContent = codes[tier].badge;
      timeEl.textContent = 'Diferencia con la meta: +' + (gapMs/1000).toFixed(3) + 's';
      result.dataset.tier = tier;
      emailStep.hidden = false;
      codeStep.hidden = true;
    }

    function revealCode(tier){
      codeStep.hidden = false;
      emailStep.hidden = true;
      codeValue.textContent = codes[tier].code;
      codeDesc.textContent = codes[tier].desc;
      saveResult(tier);
    }

    function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    function captureEmail(email){
      var tags = section.dataset.emailTags || 'newsletter,vuelta-rapida';
      var body = new URLSearchParams();
      body.append('form_type','customer');
      body.append('utf8','✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', tags);
      return fetch('/contact', {
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
        body: body.toString()
      }).catch(function(){});
    }

    if (emailSubmit){
      emailSubmit.addEventListener('click', function(){
        var v = (emailInput.value || '').trim();
        if (!validEmail(v)){ emailError.hidden = false; emailInput.focus(); return; }
        emailError.hidden = true;
        emailSubmit.disabled = true; emailSubmit.textContent = '...';
        var tier = parseInt(result.dataset.tier,10) || 3;
        captureEmail(v).then(function(){ revealCode(tier); });
      });
      emailInput.addEventListener('keydown', function(e){ if (e.key==='Enter'){ e.preventDefault(); emailSubmit.click(); } });
    }

    function wireCopy(btn, getText){
      if (!btn) return;
      btn.addEventListener('click', function(){
        var txt = getText();
        var done = function(){ btn.textContent='¡Copiado!'; btn.classList.add('is-copied'); setTimeout(function(){ btn.textContent='Copiar'; btn.classList.remove('is-copied'); },1800); };
        if (navigator.clipboard){ navigator.clipboard.writeText(txt).then(done).catch(done); } else { done(); }
      });
    }
    wireCopy(copyBtn, function(){ return codeValue.textContent; });
    wireCopy(playedCopy, function(){ return playedCode.textContent; });

    if (startBtn) startBtn.addEventListener('click', startCountdown);
    if (stopBtn) stopBtn.addEventListener('click', stopRun);
  }

  function initAll(){ document.querySelectorAll('[data-section-type="bc-vr"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function(e){
    var s = e.target.querySelector('[data-section-type="bc-vr"]');
    if (s){ s.dataset.bcvrInit=''; init(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BC-WhatsApp-Flotante"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function init(section){
    if (section.dataset.bcwaInit === 'true') return;
    section.dataset.bcwaInit = 'true';

    var bubble = section.querySelector('[data-bubble]');
    var closeBtn = section.querySelector('[data-bubble-close]');
    var showBubble = section.dataset.showBubble === 'true';
    var delay = parseInt(section.dataset.bubbleDelay, 10) || 3000;
    var storeKey = 'bcWaBubbleClosed';

    if (bubble && showBubble) {
      var alreadyClosed = false;
      try { alreadyClosed = sessionStorage.getItem(storeKey) === '1'; } catch(e){}
      if (!alreadyClosed) {
        setTimeout(function(){ bubble.hidden = false; }, delay);
      }
    }

    if (closeBtn && bubble) {
      closeBtn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        bubble.hidden = true;
        try { sessionStorage.setItem(storeKey, '1'); } catch(e){}
      });
    }
  }
  function initAll(){ document.querySelectorAll('[data-section-type="bc-wa"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function(e){
    var s = e.target.querySelector('[data-section-type="bc-wa"]');
    if (s){ s.dataset.bcwaInit=''; init(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-announcement-bar"] && !Shopify.designMode) return;
  try {
    
/* BC Announcement Bar v2.0 · Pro-Conversion */
(function() {
  'use strict';

  const STORAGE_KEY = 'bc-announce-dismissed';

  function initAnnounce(section) {
    if (section.dataset.bcInitialized === 'true') return;
    section.dataset.bcInitialized = 'true';

    const allMessages = Array.from(section.querySelectorAll('.bc-announce__message'));
    if (allMessages.length === 0) return;

    const closeBtn = section.querySelector('[data-announce-close]');
    const prevBtn = section.querySelector('[data-announce-prev]');
    const nextBtn = section.querySelector('[data-announce-next]');
    const dots = section.querySelectorAll('.bc-announce__dot');
    const progressBar = section.querySelector('[data-progress-bar]');

    const enableDismiss = section.dataset.enableDismiss === 'true';
    const showProgress = section.dataset.showProgress === 'true';
    const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    const freeShippingThreshold = parseInt(section.dataset.freeShippingThreshold, 10) || 5000000;
    const cartTotal = parseInt(section.dataset.cartTotal, 10) || 0;
    const customerLoggedIn = section.dataset.customerLoggedIn === 'true';
    const cartItemCount = parseInt(section.dataset.cartItemCount, 10) || 0;

    if (enableDismiss) {
      try {
        if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
          section.classList.add('is-hidden');
          return;
        }
      } catch (e) {}
    }

    const now = new Date();
    const visibleMessages = allMessages.filter(msg => {
      const startDate = msg.dataset.startDate;
      if (startDate && new Date(startDate) > now) {
        msg.classList.add('is-hidden-condition');
        return false;
      }
      const endDate = msg.dataset.endDate;
      if (endDate && new Date(endDate) < now) {
        msg.classList.add('is-expired');
        return false;
      }
      const condition = msg.dataset.messageCondition || 'always';
      let show = true;
      if (condition === 'new_visitor') {
        try { show = !localStorage.getItem('bc-returning-visitor'); } catch (e) { show = true; }
      } else if (condition === 'returning_visitor') {
        try { show = !!localStorage.getItem('bc-returning-visitor'); } catch (e) { show = false; }
      } else if (condition === 'cart_empty') {
        show = cartItemCount === 0;
      } else if (condition === 'cart_with_items') {
        show = cartItemCount > 0;
      } else if (condition === 'logged_in') {
        show = customerLoggedIn;
      } else if (condition === 'guest') {
        show = !customerLoggedIn;
      }
      if (!show) msg.classList.add('is-hidden-condition');
      return show;
    });

    try { localStorage.setItem('bc-returning-visitor', 'true'); } catch (e) {}

    if (visibleMessages.length === 0) {
      section.classList.add('is-hidden');
      return;
    }

    allMessages.forEach(m => { m.classList.remove('is-active'); m.setAttribute('aria-hidden', 'true'); });
    visibleMessages[0].classList.add('is-active');
    visibleMessages[0].setAttribute('aria-hidden', 'false');

    function updateShippingProgress() {
      const shippingMessages = section.querySelectorAll('.bc-announce__message--shipping');
      shippingMessages.forEach(msg => {
        const textEl = msg.querySelector('[data-shipping-text]');
        const barEl = msg.querySelector('[data-shipping-bar]');
        if (!textEl || !barEl) return;

        const currentCartTotal = parseInt(section.dataset.cartTotal, 10) || 0;
        const remaining = freeShippingThreshold - currentCartTotal;
        const percentage = Math.min((currentCartTotal / freeShippingThreshold) * 100, 100);

        if (remaining <= 0) {
          textEl.textContent = '¡Tienes envío gratis en tu compra! 🎉';
          barEl.style.width = '100%';
          barEl.classList.add('is-complete');
        } else {
          const remainingCLP = '$' + (remaining / 100).toLocaleString('es-CL');
          textEl.textContent = `Te faltan ${remainingCLP} para envío gratis`;
          barEl.style.width = percentage + '%';
          barEl.classList.remove('is-complete');
        }
      });
    }
    updateShippingProgress();

    async function refreshCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        section.dataset.cartTotal = cart.total_price;
        section.dataset.cartItemCount = cart.item_count;
        updateShippingProgress();
      } catch (e) {}
    }

    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('cart:refresh', refreshCart);

    const countdownMessages = section.querySelectorAll('[data-end-date]');
    let countdownTimer = null;

    function updateCountdowns() {
      const currentTime = Date.now();
      let hasActive = false;

      countdownMessages.forEach(msg => {
        const endDate = new Date(msg.dataset.endDate).getTime();
        const diff = endDate - currentTime;

        if (diff <= 0) {
          msg.classList.add('is-expired');
          msg.classList.remove('is-active');
          return;
        }

        hasActive = true;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const h = msg.querySelector('[data-countdown-hours]');
        const m = msg.querySelector('[data-countdown-minutes]');
        const s = msg.querySelector('[data-countdown-seconds]');
        if (h) h.textContent = String(hours).padStart(2, '0');
        if (m) m.textContent = String(minutes).padStart(2, '0');
        if (s) s.textContent = String(seconds).padStart(2, '0');
      });

      if (hasActive) {
        countdownTimer = setTimeout(updateCountdowns, 1000);
      }
    }

    if (countdownMessages.length > 0) updateCountdowns();

    section.querySelectorAll('[data-whatsapp-message]').forEach(msg => {
      const link = msg.querySelector('a');
      if (!link) return;
      const waMsg = msg.dataset.whatsappMessage;
      const originalHref = link.getAttribute('href');
      if (originalHref && originalHref.includes('wa.me') && waMsg) {
        const separator = originalHref.includes('?') ? '&' : '?';
        link.setAttribute('href', originalHref + separator + 'text=' + encodeURIComponent(waMsg));
      }
    });

    let activeIndex = 0;
    let autoplayTimer = null;
    let isPaused = false;
    let progressStartTime = 0;
    let progressRaf = null;

    function getCurrentList() {
      return visibleMessages.filter(m => !m.classList.contains('is-expired'));
    }

    function updateProgressBar() {
      if (!showProgress || !progressBar) return;
      progressStartTime = Date.now();
      function tick() {
        if (isPaused) return;
        const elapsed = Date.now() - progressStartTime;
        const pct = Math.min((elapsed / autoplaySpeed) * 100, 100);
        progressBar.style.width = pct + '%';
        if (pct < 100 && !isPaused) {
          progressRaf = requestAnimationFrame(tick);
        }
      }
      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';
      progressBar.offsetHeight;
      progressRaf = requestAnimationFrame(tick);
    }

    function goToMessage(newIndex) {
      const list = getCurrentList();
      if (list.length === 0) return;
      if (newIndex < 0) newIndex = list.length - 1;
      if (newIndex >= list.length) newIndex = 0;
      if (newIndex === activeIndex) return;

      list.forEach((m, i) => {
        m.classList.toggle('is-active', i === newIndex);
        m.setAttribute('aria-hidden', i === newIndex ? 'false' : 'true');
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === newIndex);
        dot.setAttribute('aria-selected', i === newIndex ? 'true' : 'false');
      });

      activeIndex = newIndex;
      updateProgressBar();
    }

    function navigate(dir) { goToMessage(activeIndex + dir); }

    function nextMessage() {
      if (!isPaused) navigate(1);
    }

    function startAutoplay() {
      if (getCurrentList().length <= 1) return;
      stopAutoplay();
      updateProgressBar();
      autoplayTimer = setInterval(nextMessage, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
      if (progressRaf) { cancelAnimationFrame(progressRaf); progressRaf = null; }
    }

    function pauseAutoplay() { isPaused = true; }
    function resumeAutoplay() {
      isPaused = false;
      updateProgressBar();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { navigate(-1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { navigate(1); startAutoplay(); });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { goToMessage(i); startAutoplay(); });
    });

    section.addEventListener('mouseenter', pauseAutoplay);
    section.addEventListener('mouseleave', resumeAutoplay);
    section.addEventListener('focusin', pauseAutoplay);
    section.addEventListener('focusout', (e) => {
      if (!section.contains(e.relatedTarget)) resumeAutoplay();
    });

    document.addEventListener('keydown', (e) => {
      if (!section.matches(':hover') && !section.contains(document.activeElement)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1); startAutoplay(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); navigate(1); startAutoplay(); }
      if (e.key === 'Escape' && enableDismiss && closeBtn) closeBtn.click();
    });

    let touchStartX = 0;
    section.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      pauseAutoplay();
    }, { passive: true });

    section.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        navigate(diff > 0 ? 1 : -1);
      }
      setTimeout(resumeAutoplay, 1000);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) startAutoplay();
          else stopAutoplay();
        });
      }, { threshold: 0.1 });
      observer.observe(section);
    }

    if (closeBtn && enableDismiss) {
      closeBtn.addEventListener('click', () => {
        section.classList.add('is-hidden');
        stopAutoplay();
        try { sessionStorage.setItem(STORAGE_KEY, 'true'); } catch (e) {}
      });
    }

    section.querySelectorAll('[data-announce-track]').forEach(el => {
      el.addEventListener('click', () => {
        const parentMsg = el.closest('.bc-announce__message');
        const eventData = {
          event_category: 'announcement_bar',
          event_label: parentMsg ? parentMsg.dataset.messageId : 'unknown',
          message_type: parentMsg ? parentMsg.dataset.messageType : 'unknown',
          message_position: el.dataset.messagePosition
        };
        if (typeof gtag === 'function') gtag('event', 'announcement_click', eventData);
        if (typeof fbq === 'function') fbq('trackCustom', 'AnnouncementClick', eventData);
      });
    });

    if (getCurrentList().length > 1) startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="bc-announce"]').forEach(initAnnounce);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-section-type="bc-announce"]');
    if (section) initAnnounce(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function pad(v) { return v < 10 ? '0' + v : String(v); }

  function initCountdown(section) {
    if (section.dataset.bcCdInit === 'true') return;
    section.dataset.bcCdInit = 'true';

    var raw = (section.dataset.launch || '').trim();
    var tzOffset = parseFloat(section.dataset.tzOffset);
    if (isNaN(tzOffset)) tzOffset = -4; /* Chile continental por defecto */

    /* Formato esperado: YYYY-MM-DD HH:MM (hora local de la tienda) */
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return; /* fecha inválida o vacía: no hace nada */

    /* Convertir la hora local de la tienda a UTC usando el offset configurado */
    var launchUTC = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] - tzOffset, +m[5], 0);

    var timerEl = section.querySelector('[data-timer]');
    var expiredEl = section.querySelector('[data-expired]');
    var dEl = section.querySelector('[data-days]');
    var hEl = section.querySelector('[data-hours]');
    var mEl = section.querySelector('[data-mins]');
    var sEl = section.querySelector('[data-secs]');
    if (!timerEl || !dEl) return;

    var interval = null;

    function expire() {
      if (interval) clearInterval(interval);
      if (section.dataset.expiredBehavior === 'hide') {
        section.style.display = 'none';
        return;
      }
      timerEl.hidden = true;
      if (expiredEl) expiredEl.hidden = false;
    }

    function tick() {
      var diff = launchUTC - Date.now();
      if (diff <= 0) { expire(); return; }
      var secs = Math.floor(diff / 1000);
      var days = Math.floor(secs / 86400);
      var hours = Math.floor((secs % 86400) / 3600);
      var mins = Math.floor((secs % 3600) / 60);
      var s = secs % 60;
      dEl.textContent = pad(days);
      hEl.textContent = pad(hours);
      mEl.textContent = pad(mins);
      sEl.textContent = pad(s);
    }

    tick();
    interval = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="bc-countdown"]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-section-type="bc-countdown"]');
    if (s) { s.dataset.bcCdInit = ''; initCountdown(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-escuderias"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   BC · ESCUDERÍAS · v1.5 · Motor unificado
   Un solo loop rAF interpola pos → target. Drag, snap, rueda
   y autoplay escriben sobre el mismo estado: cero saltos.
   ============================================================ */
(function() {
  'use strict';

  function initCoverflow(section) {
    if (section.dataset.bcInitialized === 'true') return;
    section.dataset.bcInitialized = 'true';

    var track = section.querySelector('[data-track]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('.bc-team-card'));
    var n = items.length;
    if (n === 0) return;

    var dots = section.querySelectorAll('.bc-escuderias__dot');
    var prevBtn = section.querySelector('.bc-escuderias__nav--prev');
    var nextBtn = section.querySelector('.bc-escuderias__nav--next');
    var wrapper = section.querySelector('.bc-escuderias__wrapper');

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isCoarse = window.matchMedia('(pointer: coarse)').matches;
    var autoplayEnabled = section.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 4000;

    var cfg = {
      spacing: 250,
      depth: 150,
      rotate: 40,
      scaleActive: 1.06,
      scaleStep: 0.12,
      scaleMin: 0.7,
      yActive: -22,
      yFactor: 12,
      opacityStep: 0.28,
      maxVisible: 3.5,
      blurMax: isCoarse ? 0 : 3,   /* blur apagado en táctiles: gran costo GPU */
      stiffness: 9,                 /* velocidad con que pos persigue a target */
      momentum: 0.16                /* proyección de inercia del flick */
    };

    /* spacing responsivo según el ancho real del stage */
    function computeSpacing() {
      var w = wrapper ? wrapper.clientWidth : window.innerWidth;
      cfg.spacing = Math.max(170, Math.min(260, Math.round(w * 0.3)));
    }
    computeSpacing();

    var pos = Math.floor(n / 2);
    var target = pos;
    var dragging = false;
    var paused = false;
    var visible = true;
    var running = false;
    var raf = null, lastFrame = 0;
    var idleMs = 0, dir = 1;
    var lastRendered = null;

    function clampPos(p) { return p < 0 ? 0 : (p > n - 1 ? n - 1 : p); }

    function render(p, force) {
      /* dirty-check: no repintar si nada cambió */
      if (!force && lastRendered !== null && Math.abs(p - lastRendered) < 0.0004) return;
      lastRendered = p;

      var roundP = Math.round(p);
      for (var i = 0; i < n; i++) {
        var item = items[i];
        var diff = i - p;
        var a = Math.abs(diff);

        /* culling: tarjetas muy lejanas se ocultan y no se calculan */
        if (a > cfg.maxVisible + 1.5) {
          if (item.style.visibility !== 'hidden') {
            item.style.visibility = 'hidden';
            item.style.pointerEvents = 'none';
          }
          continue;
        }
        if (item.style.visibility === 'hidden') item.style.visibility = 'visible';

        var tx = diff * cfg.spacing;
        var tz = -a * cfg.depth;
        var ty = cfg.yActive * Math.max(0, 1 - a) + a * cfg.yFactor;
        var ry = -Math.max(-1, Math.min(1, diff)) * cfg.rotate;
        var sc = Math.max(cfg.scaleMin, cfg.scaleActive - a * cfg.scaleStep);
        var op = a > cfg.maxVisible ? 0 : Math.max(0, 1 - a * cfg.opacityStep);
        var br = Math.max(0.5, 1.05 - a * 0.12);

        item.style.transform =
          'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,' + tz.toFixed(2) + 'px)' +
          ' rotateY(' + ry.toFixed(2) + 'deg)' +
          ' scale(' + sc.toFixed(3) + ')';
        item.style.opacity = op.toFixed(3);
        item.style.zIndex = String(Math.round(1000 - a * 10));
        if (cfg.blurMax > 0) {
          var bl = Math.min(cfg.blurMax, a);
          item.style.filter = 'brightness(' + br.toFixed(2) + ') blur(' + bl.toFixed(2) + 'px)';
        } else {
          item.style.filter = 'brightness(' + br.toFixed(2) + ')';
        }
        item.style.pointerEvents = op < 0.1 ? 'none' : 'auto';
        item.setAttribute('data-active', roundP === i);
        item.setAttribute('aria-hidden', roundP !== i);
      }
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === roundP);
      if (!autoplayEnabled) {
        if (prevBtn) prevBtn.disabled = roundP <= 0;
        if (nextBtn) nextBtn.disabled = roundP >= n - 1;
      }
    }

    /* ---- Loop único: frame-rate independent ---- */
    function loop(now) {
      if (!running) return;
      var dt = Math.min(64, now - lastFrame) / 1000;
      lastFrame = now;

      if (!dragging) {
        var d = target - pos;
        if (prefersReduced) {
          pos = target;
        } else if (Math.abs(d) > 0.0006) {
          pos += d * Math.min(1, cfg.stiffness * dt);
          if (Math.abs(target - pos) < 0.0006) pos = target;
        } else {
          pos = target;
        }
      }

      /* autoplay ping-pong integrado en el mismo loop */
      if (autoplayEnabled && !prefersReduced && !paused && !dragging && visible && n > 1) {
        idleMs += dt * 1000;
        if (idleMs >= autoplaySpeed) {
          idleMs = 0;
          var cur = Math.round(target);
          var next = cur + dir;
          if (next > n - 1) { dir = -1; next = cur - 1; }
          else if (next < 0) { dir = 1; next = cur + 1; }
          target = clampPos(next);
        }
      }

      render(pos, false);

      /* ahorro: si no hay autoplay y todo está quieto, el loop se apaga */
      if (!autoplayEnabled && !dragging && pos === target) {
        running = false;
        return;
      }
      raf = requestAnimationFrame(loop);
    }

    function start() {
      if (running) return;
      running = true;
      lastFrame = performance.now();
      raf = requestAnimationFrame(loop);
    }
    function stopLoop() {
      running = false;
      if (raf) cancelAnimationFrame(raf);
    }
    function wake() { idleMs = 0; start(); }

    function navigate(step) { target = clampPos(Math.round(target) + step); wake(); }
    function goTo(idx) { target = clampPos(idx); wake(); }

    /* ---- Controles ---- */
    if (prevBtn) prevBtn.addEventListener('click', function () { navigate(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { navigate(1); });
    for (var di = 0; di < dots.length; di++) {
      (function (idx) { dots[idx].addEventListener('click', function () { goTo(idx); }); })(di);
    }

    var movedSinceDown = 0;

    items.forEach(function (item, idx) {
      var linkEl = item.querySelector('.bc-team-card__link');
      item.addEventListener('click', function (e) {
        if (e.target.closest('.bc-team-card__driver-link')) return;
        if (movedSinceDown > 6) return; /* fue un drag, no un click */
        if (Math.round(target) !== idx) {
          e.preventDefault(); goTo(idx);
        } else if (linkEl) {
          var url = linkEl.getAttribute('data-card-url');
          if (url && url !== '#') window.location.href = url;
        }
      });
      if (linkEl) {
        linkEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var url = linkEl.getAttribute('data-card-url');
            if (Math.round(target) !== idx) goTo(idx);
            else if (url && url !== '#') window.location.href = url;
          }
        });
      }
    });

    /* ---- Teclado ---- */
    document.addEventListener('keydown', function (e) {
      if (!visible) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); navigate(1); }
    });

    /* ---- Drag con Pointer Events (mouse + touch unificado) ----
       touch-action: pan-y en CSS deja el scroll vertical al navegador;
       si el gesto es vertical llega pointercancel y el drag se anula solo. */
    var startX = 0, startPos = 0, lastX = 0, lastT = 0, vel = 0;

    function dragStart(x) {
      dragging = true;
      startX = x; startPos = pos; lastX = x; lastT = performance.now();
      vel = 0; movedSinceDown = 0;
      paused = true;
      wake();
    }
    function dragMove(x) {
      if (!dragging) return;
      var now = performance.now(), dt = now - lastT;
      if (dt > 0) {
        var v = (x - lastX) / dt;
        vel = vel * 0.8 + v * 0.2; /* velocidad suavizada → flick estable */
        lastX = x; lastT = now;
      }
      movedSinceDown = Math.max(movedSinceDown, Math.abs(x - startX));
      var p = startPos - (x - startX) / cfg.spacing;
      if (p < 0) p = p * 0.35;
      if (p > n - 1) p = (n - 1) + (p - (n - 1)) * 0.35;
      pos = p;
    }
    function dragEnd() {
      if (!dragging) return;
      dragging = false;
      var flick = vel * cfg.momentum * 1000 / cfg.spacing;
      var t = Math.round(pos - flick);
      var cur = Math.round(startPos);
      if (t > cur + 2) t = cur + 2;
      if (t < cur - 2) t = cur - 2;
      target = clampPos(t);
      paused = false;
      idleMs = -800; /* respiro antes de reanudar autoplay */
      wake();
    }

    if (wrapper) {
      wrapper.addEventListener('mouseenter', function () { paused = true; });
      wrapper.addEventListener('mouseleave', function () { paused = false; wake(); });

      if (window.PointerEvent) {
        wrapper.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          dragStart(e.clientX);
        });
        window.addEventListener('pointermove', function (e) { if (dragging) dragMove(e.clientX); });
        window.addEventListener('pointerup', dragEnd);
        window.addEventListener('pointercancel', dragEnd);
      } else {
        /* Fallback navegadores antiguos */
        wrapper.addEventListener('mousedown', function (e) { dragStart(e.clientX); });
        window.addEventListener('mousemove', function (e) { if (dragging) dragMove(e.clientX); });
        window.addEventListener('mouseup', dragEnd);
        wrapper.addEventListener('touchstart', function (e) { dragStart(e.touches[0].clientX); }, { passive: true });
        wrapper.addEventListener('touchmove', function (e) { dragMove(e.touches[0].clientX); }, { passive: true });
        wrapper.addEventListener('touchend', dragEnd);
      }

      /* Rueda / trackpad — mueve libre, luego snap suave */
      var wheelSnap = null;
      wrapper.addEventListener('wheel', function (e) {
        var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (Math.abs(d) < 2) return;
        e.preventDefault();
        paused = true;
        pos = clampPos(pos + d / (cfg.spacing * 1.4));
        target = pos;
        wake();
        if (wheelSnap) clearTimeout(wheelSnap);
        wheelSnap = setTimeout(function () {
          target = clampPos(Math.round(pos));
          paused = false;
          idleMs = -800;
          wake();
        }, 110);
      }, { passive: false });
    }

    /* ---- Visibilidad: el loop se apaga fuera del viewport ---- */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          visible = en.isIntersecting;
          if (visible) wake(); else stopLoop();
        });
      }, { threshold: 0.05 });
      obs.observe(section);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopLoop();
      else if (visible) wake();
    });

    /* ---- Resize: recalcular spacing responsivo ---- */
    var resizeT = null;
    window.addEventListener('resize', function () {
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        computeSpacing();
        render(pos, true);
      }, 120);
    });

    render(pos, true);
    start();
  }

  function initAll() { document.querySelectorAll('[data-section-type="bc-escuderias"]').forEach(initCoverflow); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-section-type="bc-escuderias"]');
    if (s) { s.dataset.bcInitialized = ''; initCoverflow(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  function formatMoney(cents) { return '$' + (cents / 100).toLocaleString('es-CL'); }
  function initHeader(section) {
    if (section.dataset.bcInitialized === 'true') return;
    section.dataset.bcInitialized = 'true';
    const searchContainer = section.querySelector('[data-search-container]');
    const searchInput = section.querySelector('[data-search-input]');
    const searchClear = section.querySelector('[data-search-clear]');
    const searchResults = section.querySelector('[data-search-results]');
    const mobileToggle = section.querySelector('[data-mobile-toggle]');
    const mobileMenu = section.querySelector('[data-mobile-menu]');
    const mobileClose = section.querySelector('[data-mobile-close]');
    const mobileOverlay = section.querySelector('[data-mobile-overlay]');
    const mobileAccordions = section.querySelectorAll('[data-mobile-accordion]');
    const cartBtn = section.querySelector('[data-open-cart]');
    const cartDrawer = section.querySelector('[data-cart-drawer]');
    const cartClose = section.querySelector('[data-cart-close]');
    const cartOverlay = section.querySelector('[data-cart-overlay]');
    const wishlistBtns = section.querySelectorAll('[data-open-wishlist]');
    const wishlistDrawer = section.querySelector('[data-wishlist-drawer]');
    const wishlistClose = section.querySelector('[data-wishlist-close]');
    const wishlistOverlay = section.querySelector('[data-wishlist-overlay]');
    const cartCount = section.querySelector('[data-cart-count]');
    const wishlistCount = section.querySelector('[data-wishlist-count]');
    let scrollPosition = 0;
    function lockScroll() { scrollPosition = window.pageYOffset; document.body.style.setProperty('--bc-scroll-y', `-${scrollPosition}px`); document.body.classList.add('bc-no-scroll'); }
    function unlockScroll() { document.body.classList.remove('bc-no-scroll'); document.body.style.removeProperty('--bc-scroll-y'); window.scrollTo(0, scrollPosition); }
    let searchDebounce = null;
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        const value = e.target.value.trim();
        searchContainer.classList.toggle('bc-header__search--has-value', value.length > 0);
        clearTimeout(searchDebounce);
        if (value.length < 2) { searchContainer.classList.remove('bc-header__search--active'); searchResults.innerHTML = ''; return; }
        searchContainer.classList.add('bc-header__search--active');
        searchResults.innerHTML = '<div class="bc-header__search-loading">Buscando...</div>';
        searchDebounce = setTimeout(() => {
          fetch(`/search/suggest.json?q=${encodeURIComponent(value)}&resources[type]=product,collection&resources[limit]=6`)
            .then(r => r.json()).then(data => renderSearchResults(data, value))
            .catch(() => { searchResults.innerHTML = `<div class="bc-header__search-empty"><div class="bc-header__search-empty-icon">🔍</div><p>Presiona Enter para buscar "${value}"</p></div>`; });
        }, 300);
      });
      searchInput.addEventListener('focus', () => { if (searchInput.value.trim().length >= 2) searchContainer.classList.add('bc-header__search--active'); });
      document.addEventListener('click', (e) => { if (searchContainer && !searchContainer.contains(e.target)) searchContainer.classList.remove('bc-header__search--active'); });
    }
    if (searchClear) { searchClear.addEventListener('click', () => { searchInput.value = ''; searchContainer.classList.remove('bc-header__search--has-value', 'bc-header__search--active'); searchResults.innerHTML = ''; searchInput.focus(); }); }
    function renderSearchResults(data, query) {
      let html = '';
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
      if (products.length > 0) {
        html += '<div class="bc-header__search-group"><h4 class="bc-header__search-group-title">Productos</h4>';
        products.forEach(p => { html += `<a href="${p.url}" class="bc-header__search-result">${p.image ? `<img src="${p.image}" class="bc-header__search-result-img" alt="">` : '<div class="bc-header__search-result-img"></div>'}<div class="bc-header__search-result-info"><span class="bc-header__search-result-title">${p.title}</span>${p.price ? `<span class="bc-header__search-result-price">${p.price}</span>` : ''}</div></a>`; });
        html += '</div>';
      }
      if (collections.length > 0) {
        html += '<div class="bc-header__search-group"><h4 class="bc-header__search-group-title">Colecciones</h4>';
        collections.forEach(c => { html += `<a href="${c.url}" class="bc-header__search-result"><div class="bc-header__search-result-info"><span class="bc-header__search-result-title">📁 ${c.title}</span></div></a>`; });
        html += '</div>';
      }
      if (products.length === 0 && collections.length === 0) html = `<div class="bc-header__search-empty"><div class="bc-header__search-empty-icon">🔍</div><p>Sin resultados para "${query}"</p></div>`;
      else html += `<div class="bc-header__search-group"><a href="/search?q=${encodeURIComponent(query)}" class="bc-header__search-result" style="justify-content:center;color:var(--bc-header-accent);font-weight:700;">Ver todos los resultados →</a></div>`;
      searchResults.innerHTML = html;
    }
    document.addEventListener('keydown', (e) => { if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); if (searchInput) searchInput.focus(); } if (e.key === 'Escape') { if (searchContainer) searchContainer.classList.remove('bc-header__search--active'); closeMobileMenu(); closeCartDrawer(); closeWishlistDrawer(); } });
    function openMobileMenu() { if (!mobileMenu) return; mobileMenu.classList.add('is-open'); mobileMenu.setAttribute('aria-hidden', 'false'); if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true'); lockScroll(); }
    function closeMobileMenu() { if (!mobileMenu) return; mobileMenu.classList.remove('is-open'); mobileMenu.setAttribute('aria-hidden', 'true'); if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false'); unlockScroll(); }
    if (mobileToggle) { mobileToggle.addEventListener('click', (e) => { e.stopPropagation(); const isOpen = mobileMenu.classList.contains('is-open'); if (isOpen) closeMobileMenu(); else openMobileMenu(); }); }
    if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);
    mobileAccordions.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const item = btn.closest('.bc-header__mobile-item');
        const wasOpen = item.classList.contains('is-open');
        mobileAccordions.forEach(otherBtn => { const otherItem = otherBtn.closest('.bc-header__mobile-item'); if (otherItem !== item) { otherItem.classList.remove('is-open'); otherBtn.setAttribute('aria-expanded', 'false'); } });
        item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
      });
    });
    function openCartDrawer() { if (!cartDrawer) return; closeMobileMenu(); cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false'); lockScroll(); refreshCart(); }
    function closeCartDrawer() { if (!cartDrawer) return; cartDrawer.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden', 'true'); if (!mobileMenu.classList.contains('is-open')) unlockScroll(); }
    if (cartBtn) cartBtn.addEventListener('click', openCartDrawer);
    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
    async function refreshCart() { try { const r = await fetch('/cart.js'); const cart = await r.json(); renderCart(cart); } catch (e) { console.error('Error loading cart:', e); } }
    function renderCart(cart) {
      const body = section.querySelector('[data-cart-drawer-body]');
      const foot = section.querySelector('[data-cart-drawer-foot]');
      const drawerCount = section.querySelector('[data-cart-drawer-count]');
      const subtotal = section.querySelector('[data-cart-subtotal]');
      if (drawerCount) drawerCount.textContent = cart.item_count;
      if (cartCount) { cartCount.textContent = cart.item_count; cartCount.classList.toggle('is-empty', cart.item_count === 0); }
      if (cart.item_count === 0) { body.innerHTML = `<div class="bc-header__drawer-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg><p>Tu carrito está vacío</p><a href="/collections/all" class="bc-header__drawer-empty-cta">Explorar productos</a></div>`; if (foot) foot.style.display = 'none';
      } else {
        let html = '';
        cart.items.forEach(item => { html += `<div class="bc-header__cart-item" data-key="${item.key}"><img src="${item.image}" alt="${item.title}" class="bc-header__cart-item-img"><div class="bc-header__cart-item-info"><h4 class="bc-header__cart-item-title">${item.product_title}</h4>${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="bc-header__cart-item-variant">${item.variant_title}</p>` : ''}<div class="bc-header__cart-item-foot"><div class="bc-header__cart-item-qty"><button data-qty-action="dec" data-key="${item.key}">−</button><span>${item.quantity}</span><button data-qty-action="inc" data-key="${item.key}">+</button></div><span class="bc-header__cart-item-price">${formatMoney(item.final_line_price)}</span></div></div><button class="bc-header__cart-item-remove" data-qty-action="remove" data-key="${item.key}" aria-label="Eliminar">✕</button></div>`; });
        body.innerHTML = html;
        if (foot) { foot.style.display = ''; if (subtotal) subtotal.textContent = formatMoney(cart.total_price); }
        body.querySelectorAll('[data-qty-action]').forEach(btn => { btn.addEventListener('click', () => handleCartAction(btn)); });
      }
      updateShippingBar(cart.total_price);
    }
    async function handleCartAction(btn) {
      const action = btn.dataset.qtyAction; const key = btn.dataset.key;
      const item = cartDrawer.querySelector(`[data-key="${key}"]`); if (!item) return;
      let newQty = parseInt(item.querySelector('.bc-header__cart-item-qty span').textContent, 10);
      if (action === 'inc') newQty++; else if (action === 'dec') newQty = Math.max(0, newQty - 1); else if (action === 'remove') newQty = 0;
      try { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: newQty }) }); refreshCart(); document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) { console.error(e); }
    }
    function updateShippingBar(total) {
      const shipping = section.querySelector('[data-cart-shipping]'); if (!shipping) return;
      const threshold = parseInt(shipping.dataset.threshold, 10) || 5000000;
      const text = shipping.querySelector('[data-shipping-text]');
      const fill = shipping.querySelector('[data-shipping-fill]');
      const remaining = threshold - total;
      const pct = Math.min((total / threshold) * 100, 100);
      if (remaining <= 0) { if (text) text.textContent = '¡Tienes envío gratis! 🎉'; if (fill) { fill.style.width = '100%'; fill.classList.add('is-complete'); } }
      else { if (text) text.textContent = `Te faltan ${formatMoney(remaining)} para envío gratis`; if (fill) { fill.style.width = pct + '%'; fill.classList.remove('is-complete'); } }
    }
    document.addEventListener('cart:added', () => { openCartDrawer(); if (cartCount) { cartCount.classList.remove('bc-pulse'); setTimeout(() => cartCount.classList.add('bc-pulse'), 10); } });
    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('submit', async (e) => { const form = e.target; if (form.action && form.action.includes('/cart/add')) { e.preventDefault(); const formData = new FormData(form); try { await fetch('/cart/add.js', { method: 'POST', body: formData }); document.dispatchEvent(new CustomEvent('cart:added')); } catch (err) { console.error(err); } } });
    const WISHLIST_KEY = 'bc-wishlist';
    function getWishlist() { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; } }
    function updateWishlistCount() { const list = getWishlist(); if (wishlistCount) { wishlistCount.textContent = list.length; wishlistCount.classList.toggle('is-empty', list.length === 0); } const drawerCount = section.querySelector('[data-wishlist-drawer-count]'); if (drawerCount) drawerCount.textContent = list.length; }
    updateWishlistCount();
    function openWishlistDrawer() { if (!wishlistDrawer) return; closeMobileMenu(); wishlistDrawer.classList.add('is-open'); wishlistDrawer.setAttribute('aria-hidden', 'false'); lockScroll(); renderWishlist(); }
    function closeWishlistDrawer() { if (!wishlistDrawer) return; wishlistDrawer.classList.remove('is-open'); wishlistDrawer.setAttribute('aria-hidden', 'true'); if (!mobileMenu.classList.contains('is-open')) unlockScroll(); }
    function renderWishlist() {
      const body = section.querySelector('[data-wishlist-body]'); if (!body) return;
      const list = getWishlist();
      if (list.length === 0) body.innerHTML = `<div class="bc-header__drawer-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg><p>Tu wishlist está vacía</p><a href="/collections/all" class="bc-header__drawer-empty-cta">Explorar productos</a></div>`;
      else {
        let html = '';
        list.forEach(item => { html += `<div class="bc-header__cart-item" data-id="${item.id}"><img src="${item.image}" alt="${item.title}" class="bc-header__cart-item-img"><div class="bc-header__cart-item-info"><h4 class="bc-header__cart-item-title"><a href="${item.url}" style="color:inherit;text-decoration:none;">${item.title}</a></h4><div class="bc-header__cart-item-foot"><span class="bc-header__cart-item-price">${item.price || ''}</span><button class="bc-header__cart-item-remove" data-wishlist-remove="${item.id}">✕</button></div></div></div>`; });
        body.innerHTML = html;
        body.querySelectorAll('[data-wishlist-remove]').forEach(btn => { btn.addEventListener('click', () => { const id = btn.dataset.wishlistRemove; const newList = getWishlist().filter(i => i.id !== id); localStorage.setItem(WISHLIST_KEY, JSON.stringify(newList)); updateWishlistCount(); renderWishlist(); }); });
      }
    }
    wishlistBtns.forEach(btn => btn.addEventListener('click', openWishlistDrawer));
    if (wishlistClose) wishlistClose.addEventListener('click', closeWishlistDrawer);
    if (wishlistOverlay) wishlistOverlay.addEventListener('click', closeWishlistDrawer);
    window.addEventListener('storage', (e) => { if (e.key === WISHLIST_KEY) updateWishlistCount(); });
    window.bcWishlist = { add: (product) => { const list = getWishlist(); if (!list.find(i => i.id === product.id)) { list.push(product); localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); updateWishlistCount(); } }, remove: (id) => { const list = getWishlist().filter(i => i.id !== id); localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); updateWishlistCount(); }, has: (id) => getWishlist().some(i => i.id === id), toggle: (product) => { const list = getWishlist(); const exists = list.find(i => i.id === product.id); if (exists) window.bcWishlist.remove(product.id); else window.bcWishlist.add(product); }, count: () => getWishlist().length };
    section.querySelectorAll('[data-header-track]').forEach(el => { el.addEventListener('click', () => { const eventData = { event_category: 'header', event_label: el.dataset.headerTrack, menu_label: el.dataset.menuLabel || '', mega_item: el.dataset.megaItem || '', mega_col: el.dataset.megaCol || '' }; if (typeof gtag === 'function') gtag('event', 'header_click', eventData); if (typeof fbq === 'function') fbq('trackCustom', 'HeaderClick', eventData); }); });
  }
  function initAll() { document.querySelectorAll('[data-section-type="bc-header"]').forEach(initHeader); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', (e) => { const section = e.target.querySelector('[data-section-type="bc-header"]'); if (section) initHeader(section); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-hero-cinematic"] && !Shopify.designMode) return;
  try {
    
/* BC Hero Cinematic v2.1 · Custom Controls */
(function() {
  'use strict';

  function initHero(section) {
    if (section.dataset.bcInitialized === 'true') return;
    section.dataset.bcInitialized = 'true';

    const allSlides = Array.from(section.querySelectorAll('.bc-hero__slide'));
    if (allSlides.length === 0) return;

    const dots = section.querySelectorAll('.bc-hero__dot');
    const prevBtn = section.querySelector('[data-nav-prev]');
    const nextBtn = section.querySelector('[data-nav-next]');
    const counterCurrent = section.querySelector('[data-counter-current]');
    const videos = section.querySelectorAll('[data-slide-video]');
    const ariaAnnouncer = section.querySelector('[data-aria-announcer]');
    const customerLoggedIn = section.dataset.customerLoggedIn === 'true';
    const cartItemCount = parseInt(section.dataset.cartItemCount, 10) || 0;

    const autoplayEnabled = section.dataset.autoplay === 'true';
    const defaultAutoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const now = new Date();
    const visibleSlides = allSlides.filter(slide => {
      const startDate = slide.dataset.startDate;
      if (startDate && new Date(startDate) > now) {
        slide.classList.add('is-hidden-condition');
        return false;
      }
      const endDate = slide.dataset.endDate;
      if (endDate && new Date(endDate) < now) {
        slide.classList.add('is-expired');
        return false;
      }
      const condition = slide.dataset.displayCondition || 'always';
      let show = true;
      if (condition === 'new_visitor') {
        try { show = !localStorage.getItem('bc-hero-returning'); } catch (e) { show = true; }
      } else if (condition === 'returning_visitor') {
        try { show = !!localStorage.getItem('bc-hero-returning'); } catch (e) { show = false; }
      } else if (condition === 'cart_empty') {
        show = cartItemCount === 0;
      } else if (condition === 'cart_with_items') {
        show = cartItemCount > 0;
      } else if (condition === 'logged_in') {
        show = customerLoggedIn;
      } else if (condition === 'guest') {
        show = !customerLoggedIn;
      }
      if (!show) slide.classList.add('is-hidden-condition');
      return show;
    });

    try { localStorage.setItem('bc-hero-returning', 'true'); } catch (e) {}

    if (visibleSlides.length === 0) {
      if (allSlides.length > 0) {
        allSlides[0].classList.remove('is-hidden-condition', 'is-expired');
        visibleSlides.push(allSlides[0]);
      } else {
        return;
      }
    }

    allSlides.forEach(s => { s.classList.remove('is-active'); s.setAttribute('aria-hidden', 'true'); });
    visibleSlides[0].classList.add('is-active');
    visibleSlides[0].setAttribute('aria-hidden', 'false');

    let activeIndex = 0;
    let isAnimating = false;
    let isDragging = false;
    let startX = 0;
    const dragThreshold = 80;
    let autoplayTimer = null;
    let autoplayPaused = false;
    let countdownTimer = null;

    function getCurrentList() {
      return visibleSlides.filter(s => !s.classList.contains('is-expired'));
    }

    function formatIndex(n) { return String(n + 1).padStart(2, '0'); }

    function announceSlide(slide) {
      if (!ariaAnnouncer) return;
      const idx = Array.from(getCurrentList()).indexOf(slide);
      const title = slide.dataset.slideTitle || '';
      ariaAnnouncer.textContent = `Slide ${idx + 1} de ${getCurrentList().length}: ${title}`;
    }

    function handleVideoPlayback(newIndex) {
      videos.forEach((video) => {
        const parentSlide = video.closest('.bc-hero__slide');
        const list = getCurrentList();
        const slideIndex = list.indexOf(parentSlide);
        if (slideIndex === newIndex) {
          if (video.paused) {
            const playPromise = video.play();
            if (playPromise !== undefined) playPromise.catch(() => {});
          }
        } else {
          if (!video.paused) video.pause();
        }
      });
    }

    function getSpeedForSlide(slide) {
      const slideSpeed = parseInt(slide.dataset.slideSpeed, 10);
      return slideSpeed && slideSpeed >= 3000 ? slideSpeed : defaultAutoplaySpeed;
    }

    function updateProgressBar() {
      const list = getCurrentList();
      const activeSlide = list[activeIndex];
      if (!activeSlide) return;
      const activeDot = section.querySelector('.bc-hero__dot.is-active');
      if (!activeDot) return;
      const progress = activeDot.querySelector('.bc-hero__dot-progress');
      if (!progress) return;
      progress.style.transition = 'none';
      progress.style.width = '0%';
      progress.offsetHeight;
      if (autoplayEnabled && !autoplayPaused && !prefersReducedMotion) {
        const speed = getSpeedForSlide(activeSlide);
        progress.style.transition = `width ${speed}ms linear`;
        progress.style.width = '100%';
      }
    }

    function goToSlide(newIndex, fromAutoplay) {
      const list = getCurrentList();
      if (list.length === 0) return;
      if (isAnimating || newIndex === activeIndex) return;
      if (newIndex < 0) newIndex = list.length - 1;
      if (newIndex >= list.length) newIndex = 0;

      isAnimating = true;

      list[activeIndex].classList.remove('is-active');
      list[activeIndex].setAttribute('aria-hidden', 'true');
      list[newIndex].classList.add('is-active');
      list[newIndex].setAttribute('aria-hidden', 'false');

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === newIndex);
        dot.setAttribute('aria-selected', i === newIndex ? 'true' : 'false');
        const progress = dot.querySelector('.bc-hero__dot-progress');
        if (progress && i !== newIndex) {
          progress.style.transition = 'none';
          progress.style.width = '0%';
        }
      });

      if (counterCurrent) counterCurrent.textContent = formatIndex(newIndex);
      announceSlide(list[newIndex]);

      activeIndex = newIndex;
      handleVideoPlayback(newIndex);

      if (!fromAutoplay && 'vibrate' in navigator && window.innerWidth <= 720) {
        try { navigator.vibrate(10); } catch (e) {}
      }

      setTimeout(() => { isAnimating = false; }, prefersReducedMotion ? 50 : 1020);

      if (!fromAutoplay && autoplayEnabled) restartAutoplay();
      else if (autoplayEnabled) setTimeout(updateProgressBar, 50);
    }

    function navigate(direction, fromAutoplay) {
      goToSlide(activeIndex + direction, fromAutoplay);
    }

    function startAutoplay() {
      if (!autoplayEnabled || prefersReducedMotion) return;
      const list = getCurrentList();
      if (list.length <= 1) return;
      stopAutoplay();
      setTimeout(updateProgressBar, 50);
      const scheduleNext = () => {
        const activeSlide = list[activeIndex];
        const speed = getSpeedForSlide(activeSlide);
        autoplayTimer = setTimeout(() => {
          if (!autoplayPaused && !isAnimating) {
            navigate(1, true);
            scheduleNext();
          } else {
            scheduleNext();
          }
        }, speed);
      };
      scheduleNext();
    }

    function stopAutoplay() {
      if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; }
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function pauseAutoplay() {
      autoplayPaused = true;
      const activeDot = section.querySelector('.bc-hero__dot.is-active');
      if (activeDot) {
        const progress = activeDot.querySelector('.bc-hero__dot-progress');
        if (progress) {
          const computedWidth = window.getComputedStyle(progress).width;
          progress.style.transition = 'none';
          progress.style.width = computedWidth;
        }
      }
    }

    function resumeAutoplay() {
      if (!autoplayPaused) return;
      autoplayPaused = false;
      updateProgressBar();
    }

    function updateCountdowns() {
      const countdownElements = section.querySelectorAll('.bc-hero__countdown');
      const currentTime = Date.now();
      let hasActive = false;
      countdownElements.forEach(el => {
        const parentSlide = el.closest('.bc-hero__slide');
        if (!parentSlide || !parentSlide.dataset.endDate) return;
        const endDate = new Date(parentSlide.dataset.endDate).getTime();
        const diff = endDate - currentTime;
        if (diff <= 0) {
          parentSlide.classList.add('is-expired');
          if (parentSlide.classList.contains('is-active')) {
            navigate(1, false);
          }
          return;
        }
        hasActive = true;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        const d = el.querySelector('[data-countdown-days]');
        const h = el.querySelector('[data-countdown-hours]');
        const m = el.querySelector('[data-countdown-minutes]');
        const s = el.querySelector('[data-countdown-seconds]');
        if (d) d.textContent = String(days).padStart(2, '0');
        if (h) h.textContent = String(hours).padStart(2, '0');
        if (m) m.textContent = String(minutes).padStart(2, '0');
        if (s) s.textContent = String(seconds).padStart(2, '0');
      });
      if (hasActive) {
        countdownTimer = setTimeout(updateCountdowns, 1000);
      }
    }

    if (section.querySelector('.bc-hero__countdown')) updateCountdowns();

    if (prevBtn) prevBtn.addEventListener('click', () => navigate(-1, false));
    if (nextBtn) nextBtn.addEventListener('click', () => navigate(1, false));

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goToSlide(index, false));
    });

    section.querySelectorAll('[data-video-control]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const parentSlide = btn.closest('.bc-hero__slide');
        const video = parentSlide.querySelector('[data-slide-video]');
        if (!video) return;
        const pauseIcon = btn.querySelector('.bc-hero__video-icon--pause');
        const playIcon = btn.querySelector('.bc-hero__video-icon--play');
        if (video.paused) {
          video.play();
          pauseIcon.style.display = '';
          playIcon.style.display = 'none';
        } else {
          video.pause();
          pauseIcon.style.display = 'none';
          playIcon.style.display = '';
        }
      });
    });

    function isSectionInView() {
      const rect = section.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    document.addEventListener('keydown', (e) => {
      if (!isSectionInView()) return;
      if (!section.matches(':hover') && !section.contains(document.activeElement)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1, false); }
      if (e.key === 'ArrowRight') { e.preventDefault(); navigate(1, false); }
      if (e.key === 'Home') { e.preventDefault(); goToSlide(0, false); }
      if (e.key === 'End') { e.preventDefault(); goToSlide(getCurrentList().length - 1, false); }
      if (e.key === ' ') {
        e.preventDefault();
        if (autoplayPaused) resumeAutoplay();
        else pauseAutoplay();
      }
    });

    section.addEventListener('mouseenter', pauseAutoplay);
    section.addEventListener('mouseleave', resumeAutoplay);
    section.addEventListener('focusin', pauseAutoplay);
    section.addEventListener('focusout', (e) => {
      if (!section.contains(e.relatedTarget)) resumeAutoplay();
    });

    section.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
      pauseAutoplay();
    }, { passive: true });

    section.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const diff = startX - e.touches[0].clientX;
      if (Math.abs(diff) > dragThreshold) {
        navigate(diff > 0 ? 1 : -1, false);
        isDragging = false;
      }
    }, { passive: true });

    section.addEventListener('touchend', () => {
      isDragging = false;
      setTimeout(resumeAutoplay, 1000);
    });

    let mouseDragActive = false;
    section.addEventListener('mousedown', (e) => {
      if (e.target.closest('a, button')) return;
      mouseDragActive = true;
      startX = e.clientX;
    });

    section.addEventListener('mousemove', (e) => {
      if (!mouseDragActive) return;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > dragThreshold) {
        navigate(diff > 0 ? 1 : -1, false);
        mouseDragActive = false;
      }
    });

    section.addEventListener('mouseup', () => { mouseDragActive = false; });
    section.addEventListener('mouseleave', () => { mouseDragActive = false; });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            resumeAutoplay();
            handleVideoPlayback(activeIndex);
          } else {
            pauseAutoplay();
            videos.forEach(v => { if (!v.paused) v.pause(); });
          }
        });
      }, { threshold: 0.1 });
      observer.observe(section);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        pauseAutoplay();
        videos.forEach(v => { if (!v.paused) v.pause(); });
      } else {
        resumeAutoplay();
        handleVideoPlayback(activeIndex);
      }
    });

    section.querySelectorAll('[data-hero-track]').forEach(el => {
      el.addEventListener('click', () => {
        const parentSlide = el.closest('.bc-hero__slide');
        const eventData = {
          event_category: 'hero_cinematic',
          event_label: parentSlide ? parentSlide.dataset.slideId : 'global',
          slide_title: parentSlide ? parentSlide.dataset.slideTitle : 'global',
          cta_type: el.dataset.heroTrack,
          cta_position: el.dataset.ctaPosition
        };
        if (typeof gtag === 'function') gtag('event', 'hero_cta_click', eventData);
        if (typeof fbq === 'function') fbq('trackCustom', 'HeroCTAClick', eventData);
      });
    });

    handleVideoPlayback(0);
    if (autoplayEnabled) setTimeout(startAutoplay, 1200);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="bc-hero"]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-section-type="bc-hero"]');
    if (section) initHero(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
